<script setup lang="ts">
const { year, num } = useRoute().params;

const { data } = await useFetch(
  () => `/api/contest/detail?yearnum=${year}-${num}`,
);

if (!data || !data.value) {
  throw createError({
    statusCode: 404,
    message: "Contest not found",
  });
}

// パンくず
useBreadcrumbs([
  { name: "TOP", path: "/" },
  { name: "コンテスト受賞歴", path: "/contents.php/contest" },
  { name: `${year}年度受賞作品`, path: `/contents.php/contest${year}` },
  {
    name: `${data.value.contest}${data.value?.bumon ?? ""}`,
    path: `/html/contest/${year}/${year}-${num}`,
  },
]);

useHead({
  title: `${year}年${data.value.contest + data.value.bumon}受賞作品 | ${
    data.value.award.name
  }`,
  meta: [
    {
      name: "description",
      content:
        `${data.value.bumon}の${data.value.award.name}作品です。` +
        `${data.value.text ? `施工のポイントは、${data.value.text}` : ""}`,
    },
    {
      property: "og:title",
      content: `${year}年${data.value.contest + data.value.bumon}受賞作品 | ${
        data.value.award.name
      }`,
    },
    {
      property: "og:image",
      content: `https://static.famitei.co.jp${data.value.images[0]}`,
    },
  ],
});
</script>

<template>
  <div class="p-contest__detail wrapper" v-if="data">
    <div class="mb-8">
      <ImageEl
        class="max-w-[200px] mx-auto mb-4"
        :src="data.maker.img"
        alt="コンテストロゴ"
        width="500"
        height="150"
        sizes="sm:100% md:200px"
        format="webp"
      />
      <h1 class="text-lg text-center">
        <p>{{ data.contest }}</p>
        <p>
          {{ data.bumon }}<b class="text-red-600">{{ data.award.name }}</b
          >作品
        </p>
      </h1>
    </div>
    <div class="w-fit mx-auto relative">
      <ImageEl
        :src="data.award.img"
        :alt="data.award.name"
        class="award-img"
        width="300"
        height="300"
        sizes="100px"
        format="webp"
      />
      <ImageEl
        v-for="(i, index) in data.images"
        class="sekou-img"
        provider="customimgproxy"
        width="400"
        height="300"
        sizes="sm:100vw md:400px"
        format="webp"
        fit="auto"
        :key="index"
        :src="`https://static.famitei.co.jp/${i}`"
        :alt="`${data.contest} 画像${index + 1}`"
      />
    </div>
    <div class="p-contest__detail-point mx-auto mb-8">
      <h2 class="point_title">
        <span class="p-contest__light-icon"></span>
        施工のポイント
      </h2>
      <p class="point-text">{{ data.text }}</p>
      <div class="tantou">
        <ImageEl
          v-if="data.tantou.image_key"
          class="flex items-center"
          :src="
            'http://famitei.jp/image/staff/' + data.tantou.image_key + '.jpg'
          "
          :alt="data.tantou.name"
          width="140"
          height="140"
          sizes="md:100% lg:140px"
          format="webp"
        />
        <p class="ml-5">担当: {{ data.tantou.name }}</p>
      </div>
    </div>
    <div class="p-contest__detail-point mb-8" v-if="data.comment">
      <h2 class="point_title">
        <span class="p-contest__light-icon"></span>
        TOEX審査員のコメント
      </h2>
      <p class="point-text">{{ data.comment }}</p>
    </div>

    <div class="w-full bg-white bg-opacity-80 p-4 sticky bottom-0">
      <div
        class="flex flex-col items-center justify-between gap-4 max-w-[400px] mx-auto"
      >
        <FormOpen class="w-full" :sekou_cd="data.sekou_cd ?? ''">
          資料請求・お問い合わせ
        </FormOpen>
      </div>
    </div>
    <div class="p-4">
      <NuxtLink
        v-if="data.sekou_cd"
        :to="`/sekou/detail/${data.sekou_cd}`"
        class="block w-full max-w-[400px] p-4 rounded bg-gray-500 hover:bg-gray-600 text-white mx-auto text-center"
      >
        この作品の施工例を見る
        <Icon class="rotate-90" size="18" name="mdi:chevron-up" />
      </NuxtLink>
    </div>
  </div>
</template>
<style scoped lang="scss">
.p-contest__detail {
  .maker-img {
    @apply inline mb-3;
  }
  .sekou-img {
    @apply m-auto mb-5;
  }
  .award-img {
    @apply absolute -top-4 -left-4 w-24;
  }

  &-point {
    @apply mx-auto;
    .point_title {
      @apply pb-1 text-2xl tracking-widest border-b-2 border-black;
    }
    .point-text {
      @apply p-2 py-6 mt-1 border-t border-black;
    }
    .tantou {
      @apply flex items-center justify-center;
    }
  }
}
</style>
